import * as _ from "lodash";
import { isProduction } from "./isProduction";

/**
 * Check if the environment is blue-green
 * @returns {boolean}
 */
export const isBlueGreen: () => boolean = (): boolean =>
  isProduction() && _.includes(window.location.hostname, "deploy-app");
